import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, Validators, FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { TalkToDoctorService } from '../api-services/talk-to-doctor.service';
import { Location } from '@angular/common';
import { BsModalService } from 'ngx-bootstrap/modal';

import {
  endOfDay,
  addMonths, format, startOfHour, addHours, addMinutes, startOfMinute, getDate, parseISO
} from 'date-fns';
import {
  DAYS_IN_WEEK,
  SchedulerViewDay,
  SchedulerViewHour,
  SchedulerViewHourSegment,
  CalendarSchedulerEvent,
  CalendarSchedulerEventAction,
  startOfPeriod,
  endOfPeriod,
  addPeriod,
  subPeriod,
  SchedulerDateFormatter,
  SchedulerEventTimesChangedEvent,
  CalendarSchedulerViewComponent
} from 'angular-calendar-scheduler';
import {
  CalendarView,
  CalendarDateFormatter,
  DateAdapter
} from 'angular-calendar';
import { Subject } from 'rxjs';
import { ProfileService } from '../api-services/profile/profile.service';

function _window(): any {
  // return the global native browser window object
  return window;
}
/**
 * This component for to confirm appointment and pay for appointment.
 * In this component using razor pay for booking appointment.
 * After,success to navigate appointments page
 */
@Component({
  selector: 'app-confirm-appointment',
  templateUrl: './confirm-appointment.component.html',
  styleUrls: ['./confirm-appointment.component.css'],
  providers: [{
    provide: CalendarDateFormatter,
    useClass: SchedulerDateFormatter
  }]
})
export class ConfirmAppointmentComponent implements OnInit {
  changeAppointmentDate = true
  @ViewChild('msg') modalRef;
  app_Id;
  points: any

  get nativeWindow(): any {
    return _window();
  }
  //start of object for payment//
  options = {
    "key": "",
    "amount": "",
    "name": "",
    "description": "",
    "image": "",
    "order_id": "",
    "handler": this.confirmPayment.bind(this),
    "prefill": {
      "name": "",
      "email": ""
    },
    "notes": {
      "address": ""
    },
    "theme": {
      "color": ""
    }
  };

  //end of object of payment//

  getAppointmentInfo: any = {};
  requestForm = this.fb.group({
    appointmentId: new FormControl(''),
    doctorId: new FormControl(),
    toWhom: new FormControl("",),
    detailsDto: this.fb.group({
      id: '0',
      firstName: new FormControl(""),
      lastName: new FormControl(""),
      dob: new FormControl(""),
      genderId: new FormControl(null),
      relation: new FormControl(null),
      phoneNumber: new FormControl("")
    }),
    appointmentDate: new FormControl(""),
    appointmentTime: new FormControl(""),
    modeOfConsultation: new FormControl(""),
    additionalInfo: new FormControl(),
    service: new FormControl(""),
    refferedBy: new FormControl("")
  });


  //Event Calendar 

  CalendarView = CalendarView;

  view: CalendarView = CalendarView.Week;
  viewDate: Date = new Date();
  viewDays: number = 7;
  refresh: Subject<any> = new Subject();
  locale: string = 'en';
  hourSegments: number = 2;
  weekStartsOn: number = 1;
  startsWithToday: boolean = true;
  activeDayIsOpen: boolean = true;
  excludeDays: number[] = []; // [0];
  dayStartHour: number = 0;
  dayEndHour: number = 24;

  minDate: Date = new Date();
  maxDate: Date = endOfDay(addMonths(new Date(), 2));
  dayModifier: Function;
  hourModifier: Function;
  segmentModifier: Function;
  eventModifier: Function;
  prevBtnDisabled: boolean = false;
  nextBtnDisabled: boolean = false;
  count = 0

  events: CalendarSchedulerEvent[] = [];

  @ViewChild(CalendarSchedulerViewComponent) calendarScheduler: CalendarSchedulerViewComponent;
  actions: CalendarSchedulerEventAction[] = [
    {
      when: 'enabled',
      label: '<span class="valign-center"><i class="bi bi-x-circle-fill  iconClr"></i>Delete</span>',
      title: 'Delete',
      onClick: (event: CalendarSchedulerEvent): void => {
        this.events = this.events.filter(item => item.title !== event.title);
        this.count = 0
        this.refresh.next()
        this.requestForm.get('appointmentDate').patchValue("");
      }
    },
    {
      when: 'cancelled',
      label: '<span class="valign-center"><i class="material-icons md-18 md-red-500">autorenew</i></span>',
      title: 'Restore',
      onClick: (event: CalendarSchedulerEvent): void => {
        // console.log('Pressed action \'Restore\' on event ' + event.id);
      }
    }
  ];

  constructor(private appointmentService: TalkToDoctorService, public fb: FormBuilder, private router: Router, private _location: Location, private modalService: BsModalService, private dateAdapter: DateAdapter, private route: ActivatedRoute, private memberPts: ProfileService) {

    this.dayModifier = ((day: SchedulerViewDay): void => {
      day.cssClass = this.isDateValid(day.date) ? '' : 'cal-disabled';
    }).bind(this);

    this.segmentModifier = ((segment: SchedulerViewHourSegment): void => {
      segment.isDisabled = !this.isDateValid(segment.date);
    }).bind(this);

    this.eventModifier = ((event: CalendarSchedulerEvent): void => {
      event.isDisabled = !this.isDateValid(event.start);
    }).bind(this);

    this.dateOrViewChanged();

  }


  ngOnInit() {
    this.app_Id = this.route.snapshot.paramMap.get('id');
    let obj = {
      appointmentId: +this.app_Id
    };
    this.getPointsmember()
    /**
     * This request for get appointment details and get response object key value pairs
     * like patientname,appointment date,relation,mode of consultation etc.,.
     */
    this.appointmentService.appointmentDetails(obj).subscribe(res => {
      this.getAppointmentInfo = res;
      this.getSchedular(this.viewDate);
      this.getData(this.getAppointmentInfo);
    });
    let tempStorage;
    tempStorage = JSON.parse(sessionStorage.getItem("temp"));
    typeof tempStorage
    if (tempStorage != null) {
      this.changeAppointmentDate = false;
      setTimeout(() => {
        this.modalService.show(this.modalRef, {
          initialState: {
            backdrop: 'static',
            keyboard: false,
            message: tempStorage.message
          }
        });
      }, 10);
    } else {
      sessionStorage.removeItem("temp")
    }

  };
/**
 * This method get appointment details assign to form fields.
 * @param bookAppointment This param has a get appointment details
 */
  getData(bookAppointment) {
    this.requestForm.get('detailsDto.firstName').patchValue(bookAppointment.PatientDetails.patientFirstName);
    this.requestForm.get('detailsDto.lastName').patchValue(bookAppointment.PatientDetails.patientLastName);
    this.requestForm.get('detailsDto.genderId').patchValue(bookAppointment.PatientDetails.patientGender);
    this.requestForm.get('detailsDto.relation').patchValue(bookAppointment.PatientDetails.patientRelation);
    this.requestForm.get('detailsDto.dob').patchValue(bookAppointment.PatientDetails.patientDOB);
    this.requestForm.get('detailsDto.phoneNumber').patchValue(bookAppointment.PatientDetails.patientMobileNo);
    this.requestForm.get('modeOfConsultation').patchValue(bookAppointment.AppoitmentDetails.modeOfConsultaion);
    this.requestForm.get('appointmentTime').patchValue(format(parseISO(bookAppointment.AppoitmentDetails.appointmentTime), 'dd-MM-yyyy hh:mm a'));
    this.requestForm.get('additionalInfo').patchValue(bookAppointment.AppoitmentDetails.aditionalInfo);
    this.requestForm.get('refferedBy').patchValue(bookAppointment.AppoitmentDetails.refferedBy)
  };

  reschduleAppointment() {
    let date = this.requestForm.get('appointmentTime').value;
    let data = {
      appointmetId: this.getAppointmentInfo.appointmentId,
      appointmentDate: date,
      appointmentTime: date
    }
    this.appointmentService.memberRescheduleAppointment(data).subscribe((res: any) => {
      if (res.status) {
        sessionStorage.removeItem('confirmApp');
        sessionStorage.removeItem("temp")
        this.router.navigate(['/myappoinment']);
      } else {
        let storage: any = {}
        storage.message = res.status;
        sessionStorage.setItem('temp', JSON.stringify(storage));
        this.modalService.hide();
      }

    })
  }

  refund() {
    const obj = { appointmenId: this.app_Id };
    this.appointmentService.refundAmount(obj).subscribe((res: any) => {
      if (res.result) {
        sessionStorage.removeItem("temp");

        this.modalService.show(this.modalRef, {
          class: 'modal-sm',
          initialState: {
            backdrop: 'static',
            keyboard: false,
            message: "Refund action done.Amount will be credit within 3 or 5 working days"
          }
        });
        setTimeout(() => {
          this.modalService.hide()
          this.router.navigate(['/myappoinment'])
        }, 30);

      } else {
        this.modalService.show(this.modalRef, {
          class: 'modal-sm',
          initialState: {
            backdrop: 'static',
            keyboard: false,
            message: "Refund action is failure.Please try in your appointment page"
          }
        });
        sessionStorage.removeItem("temp");
        setTimeout(() => {
          this.modalService.hide()
          this.router.navigate(['/myappoinment'])
        }, 20);
      }
    }, err => {

    })
  };

/**
 * This method used to razor pay response take pass as request to confirm payment api.
 * If return success message to navigate appointment page.
 * @param response This parameter has razor pay response.
 */

  confirmPayment(response) {
    // this.loader = false
    let reqObj = {
      razorpay_payment_id: response.razorpay_payment_id
    };
    this.appointmentService.confirmPayment(reqObj).subscribe(data => {
      let res: any = data;
      if (res.status == 'true') {
        sessionStorage.removeItem('confirmApp');
        sessionStorage.removeItem("temp")
        window.location.href = '/myappoinment';
      } else {
        let storage: any = {}
        storage.message = res.message;
        // storage.changeDate = false;
        sessionStorage.setItem('temp', JSON.stringify(storage));
        this.modalService.hide();
        window.location.reload()
      }
    }, err => {

    })
  };
  navigatePage() {
    window.location.href = '/myappoinment';
  }

  goback() {

    sessionStorage.removeItem("temp")
    sessionStorage.removeItem('confirmApp');
    this._location.back();
  }

  /**
   * This method using to pass appointment id request and take response of payment info
   * to pass razor pay. 
   * @param id This parameter is appointment id
   */

  make_payment(id) {
    let reqObj = {
      appointmenId: id,
    };
    this.appointmentService.makePaymentOfAppointment(reqObj).subscribe(data => {
      let resp: any = data;
      if (resp.statusCode == 200) {
        this.options.key = resp.razorPay.secretKey;
        this.options.order_id = resp.razorPay.razorpayOrderId;
        this.options.amount = resp.razorPay.applicationFee; //paise
        this.options.name = resp.razorPay.merchantName;
        this.options.description = resp.razorPay.purchaseDescription;
        this.options.image = resp.razorPay.imageURL;
        this.options.prefill.name = resp.razorPay.customerName;
        this.options.prefill.email = resp.razorPay.customerEmail;
        this.options.notes.address = resp.razorPay.notes;
        this.options.theme.color = resp.razorPay.theme;
        //this.getMyAppointments();
        var rzp1 = this.nativeWindow.Razorpay(this.options);
        rzp1.open();
      }
    }, err => {
      if (err.status == 409) {
        this.modalService.show(this.modalRef, {
          class: 'modal-sm',
          initialState: {
            backdrop: 'static',
            keyboard: false,
            message: err.error.message
          }
        });
        sessionStorage.removeItem("temp")
        // this.changeAppointmentDate =false;
      }
      //Razorpay service down
      else if(err.status == 417){
        this.modalService.show(this.modalRef, {
          class: 'modal-sm',
          initialState: {
            backdrop: 'static',
            keyboard: false,
            message: err.error.razorPay.notes
          }
        });
        sessionStorage.removeItem("temp")
      }

    })

  };
/**
 * This method to user wallet has credit/points to make payment for appointment
 * @param id It is appointment id 
 */
  makePaymentOnPoints(id) {
    let reqObj = {
      appointmenId: id,
    };
    this.appointmentService.payOnPoints(reqObj).subscribe((res: any) => {
      if (res.status) {
        this.router.navigate(['/myappoinment'])
      }
    }, err => {
      if (err.status == 409) {
        this.modalService.show(this.modalRef, {
          class: 'modal-sm',
          initialState: {
            backdrop: 'static',
            keyboard: false,
            message: err.error.message
          }
        });
        sessionStorage.removeItem("temp")
        // this.changeAppointmentDate =false;
      }
    })
  }

  modalClose() {
    this.modalService.config.initialState = "";
    this.modalService.hide();
  }

  openModal(temp, id?) {
    this.modalService.show(temp,
      Object.assign({}, {
        class: (id != undefined) ? 'modal-sm' : 'gray modal-lg',
        initialState: { message: 'Please choose a payment method ', appId: id }
      })

    );



  };
  getPointsmember() {
    this.memberPts.memberDetails().subscribe(res => {
      let memberDetails: any = res;
      this.points = memberDetails.memberDetails.rewardPoints
    })
  }

  async getSchedular(date) {
    this.events = []
    let finalDate = new Date().setDate(date.getDate() + 6);
    let obj = {
      fromDate: format(date, 'dd-MM-yyyy'),
      endDate: format(finalDate, 'dd-MM-yyyy'),
      doctorId: this.getAppointmentInfo?.doctorDetails.doctorId
    };
    this.appointmentService.bookingScheduler(obj).subscribe(async data => {
      let getdata: any = data;
      this.dayEndHour = getdata.availabilityEndTime;
      this.dayStartHour = getdata.availabilityStartTime;
      await getdata.calenderEvents.forEach(ele => {
        let eventData: CalendarSchedulerEvent = {
          id: ele.id,
          start: startOfMinute(new Date(ele.start)),
          //end: addMinutes(startOfHour(addHours(new Date(1628506217195), 0)), 29),
          end: addMinutes(startOfMinute(new Date(ele.end)), ele.interval),
          title: ele.title,
          content: ele.content,
          color: ele.color,
          actions: this.actions,
          // status: 'ok' as CalendarSchedulerEventStatus,
          isClickable: ele.clickable,
          isDisabled: ele.disabled
        }
        this.events.push(eventData);
      });
      this.refresh.next();
    });
  }



  viewDaysOptionChanged(viewDays: number): void {

    this.calendarScheduler.setViewDays(viewDays);
  }

  changeDate(date: Date): void {
    this.viewDate = date;
    this.dateOrViewChanged();
  }

  changeView(view: CalendarView): void {
    this.view = view;
    this.dateOrViewChanged();
  }

  dateOrViewChanged(): void {
    

    if (this.startsWithToday) {
      this.prevBtnDisabled = !this.isDateValid(subPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1));
      this.nextBtnDisabled = !this.isDateValid(addPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1));
    } else {
      this.prevBtnDisabled = !this.isDateValid(endOfPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, subPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1)));
      this.nextBtnDisabled = !this.isDateValid(startOfPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, addPeriod(this.dateAdapter, CalendarView.Day/*this.view*/, this.viewDate, 1)));
    }

    if (this.viewDate < this.minDate) {
      this.changeDate(this.minDate);
    } else if (this.viewDate > this.maxDate) {
      this.changeDate(this.maxDate);
    }
  }

  private isDateValid(date: Date): boolean {
    return /*isToday(date) ||*/ date >= this.minDate && date <= this.maxDate;
  }

  viewDaysChanged(viewDays: number): void {
    this.viewDays = viewDays;
  }

  dayHeaderClicked(day: SchedulerViewDay): void {
    // console.log('dayHeaderClicked Day', day);
  }

  // hourClicked(hour: SchedulerViewHour): void {
  //   console.log('hourClicked Hour', hour);
  // }

  segmentClicked(action: string, segment: SchedulerViewHourSegment): void {
    this.count++;
    if (this.count == 1) {
      this.requestForm.get('appointmentTime').patchValue(segment.date);
      segment.backgroundColor = '#e8fde7';
      segment.isDisabled = true;
      let eventData: CalendarSchedulerEvent = {
        id: "",
        start: startOfMinute(new Date(segment.date)),
        color: { primary: '#e8fde7', secondary: '#e8fde7' },
        title: " ",
        actions: this.actions,
        isClickable: true,
      }
      this.events.push(eventData);
      this.refresh.next();
      this.modalService.hide();
    }
  }

  eventClicked(action: string, event: CalendarSchedulerEvent): void {
    // console.log('eventClicked Action', action);
    // console.log('eventClicked Event', event);
  }

  eventTimesChanged({ event, newStart, newEnd, type }: SchedulerEventTimesChangedEvent): void {
    const ev: CalendarSchedulerEvent = this.events.find(e => e.id === event.id);
    ev.start = newStart;
    ev.end = newEnd;
    this.refresh.next();
  }








}
